import { posthog } from 'posthog-js';

export enum InteractedChart {
  ROUTER_MODEL = 'router_model',
  ROUTER_STATUS = 'router_status',
  ROUTER_FIRMWARE = 'router_firmware',
  UPDATE_JOB_STATUS = 'update_job_status'
}

export const captureOpenExternalLink = (url: string): void => {
  posthog.capture('open_external_link', {
    url: url
  });
};

export const captureComparePlans = (): void => {
  posthog.capture('compare_plans');
};

export const continueWithTrial = (leftDays: string): void => {
  posthog.capture('continue_with_trial', {
    leftDaysOfTrialLicense: leftDays
  });
};

export const captureDownloadOnPremises = (version: string): void => {
  posthog.capture('download_on_premises_binary', {
    version: version
  });
};
export const captureNumberOfDownloadedFirmware = (
  numberOfSelectedFirmware: number,
  versions: string[]
): void => {
  posthog.capture('download_multiple_firmware', {
    numberOfSelectedFirmware: numberOfSelectedFirmware,
    versions: versions
  });
};

export const captureDownloadFirmware = (version: string): void => {
  posthog.capture('download_firmware', {
    version: version
  });
};
export const captureResendInvitation = (userUUID: string): void => {
  posthog.capture('resend_invitation', {
    userUuid: userUUID
  });
};

export const captureLanguage = (): void => {
  posthog.setPersonProperties({
    appLanguage: localStorage.getItem('currentLang')
  });
};

export const captureActionButtonAction = (
  tableId: string,
  actionId: string,
  numSelectedElements: number,
  primary = false
): void => {
  posthog.capture('trigger_action_table_action_button', {
    isPrimaryAction: primary,
    tableId: tableId,
    actionId: actionId,
    numSelectedElements: numSelectedElements
  });
};

export const captureDetailsActionButtonAction = (
  actionId: string,
  pageName: string
): void => {
  posthog.capture('trigger_details_header_action_button', {
    actionId: actionId,
    pageName: pageName
  });
};

export const captureDashboardInteraction = (
  interactedChart: InteractedChart
): void => {
  posthog.capture('interact_with_dashboard', {
    interactedChart: interactedChart
  });
};

export const capture2FaEnforcement = (enforcement: boolean) => {
  posthog.capture('enforce_2fa', { enforcement: enforcement });
};
